// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/headerBGWeb.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/images/Header_pink.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/images/headerBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/images/Header_bar_pink_color.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oxygen:wght@300;400;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;0,900;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Oxygen", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400 !important;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10vh;
}
.header-logo {
  margin-top: -5px;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.mt-m4 {
  margin-top: 1.5rem !important;
}
.mt--10 {
  margin-top: 10px;
}
.bor-r-8 {
  border-radius: 8px;
  font-size: 20px;
}
.color-00B8E9 {
  color: #00b8e9 !important;
}
.shownotbookmsg {
  margin-top: 8px !important;
  font-size: 14px;
  font-weight: 600;
  color: #999;
}
.cursor {
  cursor: pointer;
}
.div-Continue {
  width: 100%;
  padding: 6px 4.8rem !important;
}
.hide-mob {
  display: block;
}
.InvalidRequest {
  margin-bottom: 32px !important;
  font-weight: 800 !important;
  font-size: 25px !important;
}
a.navbar-brand {
  font-weight: 700 !important;
  font-size: 20px !important;
}
.show-mob {
  display: none;
}
.show-web {
  display: block;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

.px1 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.pad-profile {
  padding: 0 30px;
}
.slot-width-w {
  width: 23%;
  margin: 3px;
}
.cal-size {
  width: 80.9% !important;
  margin-left: 9.5%;
}
.p-10 {
  padding: 10rem !important;
}
.group {
  display: flex;
  justify-content: space-between;
}
.patientalertYes {
  background-color: #3e7ebc !important;
  padding: 40px 25px;
  font-size: 16px;
  text-align: center;
  font-weight: 500;
  color: #fff;
  border-radius: 8px;
}
.ReasonTitle {
  background-color: #3e7ebc;
  padding: 0.7rem 2rem;
  border-radius: 35px;
  color: #fff;
}

.non-selected-slot {
  background-color: #fff !important;
  --bs-btn-color: #eee !important;
  --bs-btn-border-color: #eee !important;
}
.non-selected-slot:hover {
  background-color: #fff !important;
  --bs-btn-color: #eee !important;
  --bs-btn-border-color: #eee !important;
}
.bg-white-reason {
  border: solid 1px #515151;
  background-color: #fff;
  color: #373737;
}
.titleactive {
  border: solid 1px #3e7ebc;
  background-color: #3e7ebc;
  color: #fff;
}
.header {
  /* height: 90px; */
  height: 75px;
  line-height: 90px;
  color: "#fff";
}

.LocName {
  margin-left: 0;
  font-size: 1.4rem;
  font-weight: 900;
}
.content-body {
  margin-top: 100px;
  margin-bottom: 40px;
}
.profile-img {
  width: 100px;
}
.top_button {
  background-color: #00b8e9 !important;
  color: #fff;
  padding: 8px;
  text-transform: CAPITALIZE;
  border-radius: 5px;
  font-weight: bold;
  font-size: 20px;
}
.blue.header {
  background-color: #3e7ebc !important;
}
.pink.header {
  background-color: #f680a0 !important;
}
.header-logo {
  padding: 6px;
  background-color: unset;
  border-radius: 3px;
  width: 85px !important;
  height: 70px !important;
}
/* .pink .pink_header-logo{
  padding: 6px;
  background-color: unset;
 max-width:214px;
 background: #fff;
} */
.pink .pink_header-logo {
  padding: 5px;
  background-color: unset;
  max-width: 135px;
  background: #fff;
  margin-top: -6px;
  border-radius: 6px;
}
.list_symtom li {
  font-weight: bold;
  margin-bottom: 10px;
}
.float-end1 {
  text-align: center;
  margin-top: 10px !important;
  flex: 1 1;
}
.buttons {
  color: #fff;
  padding-left: 40%;
  padding-right: 40%;
  margin-top: 33px;
  padding-bottom: 10px;
  padding-top: 10px;
  background: #388fa2 !important;
  width: 100%;
}
.v_button {
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  font-weight: 700 !important;
  margin-bottom: 10px !important;
}
@media (min-width: 1400px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1300px !important;
  }
}
.cus-breadcrumb {
  display: table;
  margin-left: 100% !important;
  margin-top: -24px !important;
  transform: rotate(270deg);
  color: #fff !important;
}
.username {
  font-weight: 600;
  font-size: 20px;
}
.next-available-text {
  font-size: 16px !important;
  color: #00b8e9 !important;
  font-weight: 400 !important;

  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
}

.sub_text.text-muted {
  font-size: 16px !important;
  color: #373737 !important;
  font-weight: 400 !important;
  font-weight: 800 !important;
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
}
.breadcrumb {
  font-weight: 700 !important;
}
.sub_txt {
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  line-height: 23px !important;
}
.main_txt {
  font-weight: 700 !important;
  font-size: 24px !important;
  margin-bottom: 10px !important;
}
.btn-primary {
  background-color: #3e7ebc !important;
  border-color: #3e7ebc !important;
}
.btn-primary:hover,
.btn-primary:focus {
  background-color: #3e7ebc !important;
  border-color: #3e7ebc !important;
}

.left-content {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.sub_txt2 {
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 23px !important;
}
.normal_txt p {
  text-align: justify;
}
.bi_title {
  font-size: 18px;
  margin-bottom: 16px;
  margin-top: 20px;
}
.app_button {
  margin: 5px;
  padding-left: 13px !important;
  padding-right: 13px !important;
}
/* .availableslots .slotbtn .app_button{
  margin:10px;
  padding:0px !important;
  width:171px;
  height: 60px;
} */
.DOBLable {
  font-size: 18px;
  color: #555;
  margin-bottom: 12px;
}
.availableslots .slotbtn .app_button {
  margin: 6px;
  padding: 10px !important;
  font-weight: 400 !important;
}

.react-calendar {
  width: 100% !important;
  height: auto;
  /* height: 350px; */
}

abbr[title] {
  -webkit-text-decoration: none !important;
  text-decoration: none !important;
  cursor: help !important;
  text-decoration-skip-ink: none !important;
}
.react-calendar__month-view__weekdays__weekday {
  padding: 15px !important;
  background: #e6e6e5 !important;
  border-right: 1px solid #fff !important;
  color: #373737 !important;
  font-weight: bold;
  border: solid #fff !important;
  border-radius: 6px;
  margin-top: 1px;
}
.react-calendar__tile--active {
  background: #388fa2 !important;
  color: white;
}
.react-calendar__tile {
  padding: 15px !important;
}
.react-calendar__navigation button {
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-weight: 700 !important;
  min-width: 44px;
  background: none;
  font-size: 24px;
}
.react-calendar__navigation__next-button,
.react-calendar__navigation__prev-button {
  font-size: 35px !important;
}
.react-calendar__navigation {
  display: flex;
  height: 55px !important;
  margin-bottom: 0px !important;
}

body .btn-outline-secondary {
  background-color: #00b8e9;
  --bs-btn-color: #fff;
  --bs-btn-border-color: #00b8e9;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #00b8e9;
  --bs-btn-hover-border-color: #00b8e9;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #00b8e9;
  --bs-btn-active-border-color: #00b8e9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #00b8e9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #00b8e9;
  --bs-gradient: none;
}

.availableslots .react-calendar__navigation button {
  min-width: 44px;
  background: none;
  border: none;
}
.slotbtn .react-calendar__navigation button:hover,
.slotbtn .react-calendar__navigation button:focus {
  background: none !important;
}

.big-bar {
  background: #388fa2;
  margin-left: 11px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.big-bar p {
  color: #fff;
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;

  font-weight: 700;
  font-size: 24px;
}
body .btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
  color: #515151;
  pointer-events: none;
  border-color: #515151;
  opacity: 0.2;
}
.frm_side p {
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
}
.mid_cnt {
  margin: 0 30px;
}
.big-bar2 {
  background: #00b8e9;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.big-bar2 p {
  color: #fff;
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;

  font-weight: 700;
  font-size: 24px;
}
.form-control {
  /* margin-top: 15px; */
  display: block !important;
  font-family: Oxygen, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif !important;
  font-weight: 400 !important;
  width: 100% !important;
  padding: 0.375rem 1.75rem !important;
  height: 50px;
  font-size: 18px !important;
  line-height: 1.5 !important;
  color: #495057 !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.25rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.genter_class {
  margin-left: 28px;
}
.book_appbtn {
  color: #fff !important;
  background-color: #00b8e9 !important;
  padding: 10px 40px !important;
  border: unset !important;
  font-weight: 800 !important;
}

.book_appbtn:hover {
  color: #fff !important;
  background-color: #00b8e9 !important;
  padding: 10px 40px !important;
  border: unset !important;
  font-weight: 800 !important;
}

p.error {
  color: #d32f2f;
  margin-top: 5px;
  font-size: 13px;
}
.inputStyle {
  width: 3rem !important;
  height: 3rem;
  margin: 0 1rem;
  font-size: 2rem;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
.peotp {
  font-weight: 400 !important;
  font-size: 18px !important;
}
.rotp {
  font-weight: 700 !important;
  font-size: 18px !important;
}
.book_appbtn2 {
  font-weight: 700 !important;
  font-size: 18px !important;
  margin-top: 20px;
  padding: 10px 68px !important;
  background-color: #00b8e9 !important;
  border: unset !important;
}
.book_appbtn3 {
  font-weight: 700 !important;
  font-size: 18px !important;
  margin-top: 20px;
  padding: 10px 25px !important;
  background-color: #00b8e9 !important;
  border: unset !important;
}
.peotp1 {
  font-weight: 700 !important;
  font-size: 18px !important;
}
.d_button {
  padding-left: 18px !important;
  padding-right: 18px !important;
  font-size: 16px !important;
  font-weight: bold !important;
}

.mb_bottom,
.homepage_mobile {
  display: none;
}
.d-flex.small_view,
.small_view {
  display: none !important;
}

.mobile_view {
  display: none;
}
.desktop_hide {
  display: none;
}
.fixed-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  background: round;
}

.pink.fixed-top,
.pink.mdfixed-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
  background: round;
}

.MuiAlert-filledWarning {
  background-color: red !important;
}
.css-rgrmo-MuiButtonBase-root-MuiRadio-root.Mui-checked {
  color: #00b8e9 !important;
}
.css-15vr3e2.Mui-checked {
  color: #00b8e9 !important;
}
.desktop_view {
  display: block;
}

@media (max-width: 980px) {
  .profile-billing {
    text-align: justify;
  }
  .desktop_hide {
    display: block;
  }
  .cus-breadcrumb {
    display: table;
    margin-left: 100% !important;
    margin-top: -24px !important;
    transform: rotate(270deg);
    color: #fff !important;
  }
  .fixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    background: round;
  }
  .pink.fixed-top,
  .pink.mdfixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
    background: round;
  }

  .mobile_view {
    display: block !important;
  }
  .react-calendar__navigation__prev-button,
  .react-calendar__navigation__next-button {
    font-size: 26px !important;
  }
  .app_button {
    font-size: 14px !important;
    margin: 5px !important;
  }
  .bi_title {
    font-size: 16px !important;
  }
  .mb_bottom,
  .homepage_mobile {
    display: block !important;
  }
   .desktop_view {
    display: none !important;
  } 
  .selected-reason-apt {
    background-color: #fff !important;
    color: #00b8e9 !important;
    border: unset !important;
    font-weight: 800 !important;
    text-align: center;
    padding: 5px;
  }
  .pink.selected-reason-apt {
    background-color: #fff !important;
    border: unset !important;
    font-weight: 800 !important;
    text-align: center;
    padding: 5px;
  }

  .header .container {
    text-align: center !important;
  }
  /* .navbar > .container {
    display: block !important;
  } */
  .header .container a {
    font-weight: 700 !important;
    font-size: 16px;
  }
  .header .container img {
    width: 100px;
  }

  .username {
    font-weight: 700;
    font-size: 16px;
  }

  .sub_text.text-muted {
    font-size: 14px !important;
  }
  .d_button {
    padding: 8px 8px !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
    font-size: 13px !important;
    font-weight: bold !important;
    width: 100%;
    max-width: 150px;
  }
  .div-Continue {
    width: 100%;
    padding: 10px 48px !important;
    min-width: 170px;
  }
  .breadcrumb {
    font-size: 14px !important;
  }
  .sub_txt {
    font-size: 13px !important;
  }
  .btn2 {
    width: 100% !important;
  }
  .main_txt {
    font-size: 16px !important;
  }
  .small_text,
  .n_av,
  .smbtn {
    font-size: 12px !important;
  }
  .smbtn {
    margin: 0px !important;
  }
}

p.small_view_e {
  display: none;
}
p.large_view_e {
  display: block;
}
@media (max-width: 500px) {
  .LocName {
    font-size: 15px;
    font-weight: 900;
  }
  .breadcrumb {
    margin-left: 5px !important;
  }
  .inmobile {
    max-width: 100%;
  }
  .d_view {
    display: none !important;
  }

  p.small_view_e {
    display: block;
  }
  p.large_view_e {
    display: none;
  }
  .list_symtom li {
    font-size: 12px;
  }
  .card-reason-pad {
    padding: 21px 12px;
  }
  .ReasonTitle {
    padding: 0.7rem 1rem !important;
  }
  .pd-0 {
    padding: 0 !important;
  }
  .mt--10 {
    margin-top: 10px;
  }
  .DivdateOfBirthDMY {
    padding: 5px 3px !important;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .patientalertYes {
    padding: 40px 14px;
  }
  .radio_button label span {
    font-size: 12px !important;
    padding: 1px;
  }
  .radio_button .css-j204z7-MuiFormControlLabel-root {
    margin-right: 13px !important;
    margin-left: 3px;
  }
  .mt-m4 {
    margin-top: 0.25rem !important;
  }
  .show-mob {
    display: block;
  }
  .fixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
    background: round;
  }
  .pink.fixed-top,
  .pink.mdfixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
    background: round;
  }
  .show-web {
    display: none;
  }
  .navbar-brand {
    float: left;
  }
  .mb-text-center {
    text-align: center !important;
  }
  .pad-profile {
    padding: 0 10px;
  }
  .pd-0-3 {
    padding: 0px 3px !important;
  }
  .big-bar2 p {
    font-size: 21px;
  }
  .ml-3 {
    margin-left: 18px;
  }
  .ml-26 {
    margin-left: 26px;
  }
  .font-14 {
    font-size: 14px !important;
  }
  .profile-img {
    width: 80px;
    height: 80px;
  }
  .mt--15 {
    margin-top: -15px;
  }
  .ml-37 {
    margin-left: 30% !important;
  }
  .slot-width-w {
    width: 30.5%;
    margin: 3px;
  }
  .cal-size {
    width: 100% !important;
    margin-left: 0;
  }
  .width-38 {
    width: 100% !important;
  }
  .ml--20 {
    margin-left: -20px;
  }
  .cus-breadcrumb {
    display: block;
    margin-left: 93% !important;
    margin-top: -20px !important;
    transform: rotate(270deg);
    color: #fff !important;
  }
  .ml--10 {
    margin-left: -10px;
  }
  .card-reason-pad {
    padding: 21px 12px !important;
  }
  .width-96 {
    margin: 0 4px !important;
    width: 100% !important;
    margin-top: 13px !important;
  }
  .rotp {
    font-size: 12px !important;
  }
  .pd-0 {
    padding: 0px !important;
  }
  .content-body {
    margin-top: 88px !important;
  }
  .next-available-text {
    font-size: 14px !important;
  }
  .cl-gray {
    color: #373737 !important;
  }
  .d-flex.small_view,
  .small_view {
    display: block !important;
  }
  .peotp {
    font-size: 15px !important;
  }

  .mobile_view2,
  .d-flex.large_view {
    display: none !important;
  }
  .mid_cnt {
    margin: 0px !important;
  }
  .divider_mb {
    margin-right: 0px !important;
    margin-left: 0px !important;
    margin-top: 30px !important;
  }
  .react-calendar__navigation button {
    font-size: 16px;
  }
  .dateOfBirthDDMMYYYY {
    padding: 0.375rem 0.7rem !important;
  }
  .pd-r {
    padding-right: 0px;
  }
  .header-logo {
    width: 70px !important;
    height: 60px !important;
  }
  .react-calendar__navigation__prev2-button {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .react-calendar__navigation__next2-button {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .DOBLable {
    font-size: 14px;
    color: #555;
    margin-bottom: 12px;
  }
}
@media (max-width: 380px) {
  .react-calendar__navigation__prev2-button,
  .react-calendar__navigation__next2-button {
    display: none !important;
  }
  .show-mob {
    display: block !important;
  }
  .ml-2 {
    margin-left: 2px;
  }
  .mt--10 {
    margin-top: 10px;
  }
  .fixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
    background: round;
  }

  .pink.fixed-top,
  .pink.mdfixed-top {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
    background: round;
  }
  .DOBLable {
    font-size: 14px;
    color: #555;
    margin-bottom: 12px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .pd-r {
    padding-right: 0px !important;
  }
  .ml-00 {
    margin-left: 0px;
  }
  .dateOfBirthDMY {
    padding: 5px 10px !important;
  }
  .DivdateOfBirthDMY {
    padding: 5px 3px !important;
  }
  .css-1jaw3da {
    margin-right: 12px !important;
  }
  .cus-breadcrumb {
    display: block;
    margin-left: 93% !important;
    margin-top: -20px !important;
    transform: rotate(270deg);
    color: #fff !important;
  }
  .mr-0 {
    margin-right: 0px;
  }
  .show-web {
    display: none;
  }
  .patientalertYes {
    padding: 40px 14px;
  }
  .patientalertYes a {
    color: #fff;
    text-decoration: none;
  }
  .radio_button .css-j204z7-MuiFormControlLabel-root {
    margin-right: 3px !important;
    margin-left: 0;
  }
  .radio_button label span {
    font-size: 11px !important;
    padding-left: 0px;
  }
  .slot-width-w {
    width: 31%;
    margin: 3px;
    font-size: 13px !important;
  }
  .mt-m4 {
    margin-top: 0.25rem !important;
  }
  .pad-profile {
    padding: 0 10px;
  }
  .ml-26 {
    margin-left: 26px;
  }
  .ml--20 {
    margin-left: -20px;
  }
  .ml--10 {
    margin-left: -10px;
  }
  .card-reason-pad {
    padding: 21px 12px !important;
  }
  .pd-m-0 {
    padding: 5px !important;
  }
  .ml-5 {
    margin-left: 5px !important;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 4px !important;
  }
  .react-calendar__tile {
    padding: 10px !important;
  }
  .react-calendar {
    height: 330px;
  }
  .slot_button {
    padding: 8px !important;
  }
  .small_text,
  .n_av,
  .smbtn {
    font-size: 10px !important;
  }
  .big-bar2 p {
    font-size: 16px !important;
  }
  .app_button {
    font-size: 13px !important;
    margin: 5px !important;
    padding: 10px !important;
  }
  .bopt {
    padding-left: 12px;
    padding-right: 12px;
  }
  .smt {
    font-size: 14px;
  }
  .header-logo {
    width: 70px !important;
    height: 60px !important;
  }
  .react-calendar__navigation__prev2-button {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }
  .react-calendar__navigation__next2-button {
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }
}
@media (max-width: 980px) {
  .book_appbtn {
    font-size: 16px !important;
    font-weight: 800 !important;
    width: 100% !important;
  }
  .radio_button label span {
    font-size: 14px;
  }
  .genter_class {
    margin-left: 0px;
  }
  .smbtn {
    font-size: 11px !important;
  }
  .m_button {
    margin: 0px;
  }
  .big-bar {
    background: #388fa2;
    margin-left: 0px;
    margin-right: 0px;
  }
  .big-bar p {
    font-size: 16px;
  }
  .m_button {
    margin: 5px;
    padding: 7px 17px !important;
    font-size: 12px !important;
  }
  .form-control {
    font-size: 16px !important;
  }
}
.reason {
  font-size: 14px !important;
  font-weight: bold !important;
}
body,
label,
p,
a,
span,
div,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Oxygen" !important;
}
.pd-10 {
  padding: 8px;
}
.b-width-full {
  width: 99%;
  padding: 6px !important;
}
.width-96 {
  border-bottom: solid #d9d9d9 1px;
  color: #fff;
  margin: 0 28px;
  width: 96%;
  margin-top: 5px;
}
.list-group-item {
  border: unset !important;
}
.mt--20 {
  margin-top: -20px !important;
}
.pat-title {
  font-size: 18px;
  color: #515151;
}
.css-odx107-MuiPaper-root {
  border-radius: 10px !important;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.04),
    0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
}
.hr-profile {
  margin: 0px !important;
  margin-top: 27px !important;
  margin-bottom: 10px !important;
  height: 1px;
  background: #0e0d0d;
}

.ml-37 {
  margin-left: 37%;
}
.width-38 {
  width: 38%;
  margin: 0;
}
.btn-blue {
  background-color: #00b8e9 !important;
  border-color: #00b8e9 !important;
}
.bg-white-reason:hover {
  background-color: #00b8e9 !important;
  color: #fff !important;
  border: unset !important;
}
.slot_button:hover {
  background-color: #00b8e9 !important;
  color: #fff !important;
  border: unset !important;
}
.app_button {
  background-color: #fff !important;
  color: #eee !important;
  border: solid 1px #eee !important;
}

.v_button {
  background-color: #00b8e9 !important;
  /* background-color: #bbdeeb !important;   */
  color: #fff !important;
  /* color: #000 !important; */
  border: unset !important;
}

.slot_button {
  background-color: #f0efef73 !important;
  color: #515151 !important;
  border: solid 1px #515151 !important;
  padding: 10px !important;
}
.div-right {
  float: right;
}

.color-515151 {
  color: #515151 !important;
}
.color-37 {
  color: #373737 !important;
}
.bg-white-reason .color-37:hover {
  color: #fff !important;
}
.bg-blue-btn {
  color: #fff !important;
  background-color: #4565ad !important;
  border: solid 1px #4565ad !important;
  /* background-color: #3e7ebc !important;
  border: solid 1px #3e7ebc !important; */
}
.font-20 {
  font-size: 19px;
}
.slot-card {
  padding: 2rem 3rem !important;
}
.blue-color {
  color: #3e7ebc !important;
}

.react-calendar__navigation__label {
  background-color: #3e7ebc !important;
  color: #fff !important;
  border: solid 1px #3e7ebc !important;
}
.react-calendar__navigation__arrow {
  background-color: #3e7ebc !important;
  color: #fff !important;
  border: solid 1px #3e7ebc !important;
}
.react-calendar__navigation {
  border: unset !important;
}
.react-calendar {
  border: unset !important;
}
.react-calendar__tile {
  border: solid #fff !important;
  border-radius: 6px;
  color: #373737;
  background: #f3f1f173 !important;
}
.react-calendar__month-view__days__day--weekend {
  color: unset !important;
}
.highlight {
  background: #edfafd !important;
  color: #373737 !important;
}
.selecteddate {
  background: #f0eeee !important;
  color: #373737 !important;
}
.react-calendar__tile--active {
  background: #00b8e9 !important;
  color: #fff !important;
}

/*pink css */

.pink .highlight {
  background: #e6e6e5 !important;
  color: #000 !important;
}
.pink .selecteddate {
  background: #e93e70 !important;
  color: #fff !important;
}
/* .pink .react-calendar__tile--active{
  background: #e93e70 !important;
  color: #FFF !important;
} */
.pink .react-calendar__tile:hover {
  /* background:#E6E6E5 !important; */
  color: #000 !important;
}

/* blue color */

.blue .highlight {
  /* background:#E6E6E5 !important; */
  background: #bbdeeb !important;
  color: #000 !important;
}
.blue .selecteddate {
  background: #3e7ebc !important;
  color: #fff !important;
}
.pink .react-calendar__tile--active.selecteddate {
  background: #e93e70 !important;
  color: #fff !important;
}
.blue .react-calendar__tile:hover {
  /* background:#E6E6E5 !important; */
  color: #000 !important;
}

.box-design {
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.04),
    0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  border: unset;
  border-radius: 10px;
}
.blue-f-colr {
  color: #3e7ebc;
  font-weight: 800 !important;
}
.symtoms {
  font-size: 15px !important;
  color: #373737 !important;
}
.drak-blue-btn {
  background: #3e7ebc !important;
}
.success-icon {
  width: 130px;
}
.list-group-item-action:active {
  background-color: unset !important;
}
.list-group-item-action:hover {
  background-color: unset !important;
}
.mt--0 {
  margin: 0 !important;
}

.h-27 {
  height: 30rem;
}

/* .alert_new .MuiAlert-icon {
  color: #38c390 !important;
} */

.closebtn {
  float: right;
  cursor: pointer;
}
.breadcrumb {
  cursor: pointer;
}

/* dynamic color code */
/*green */
body .pink .btn-outline-secondary {
  background-color: #f680a0;
  --bs-btn-color: #fff;
  --bs-btn-border-color: #f680a0;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f680a0;
  --bs-btn-hover-border-color: #f680a0;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f680a0;
  --bs-btn-active-border-color: #f680a0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f680a0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f680a0;
  --bs-gradient: none;
}
body .pink .btn-outline-secondary:hover,
body .pink .btn-outline-secondary:focus {
  background-color: #f680a0 !important;
  border-color: #f680a0 !important;
  color: #ffffff;
}
.pink .btn-primary,
.pink .btn-blue,
.pink .top_button {
  background-color: #f680a0 !important;
  border-color: #f680a0 !important;
  color: #ffffff;
}
.pink .color-00B8E9 {
  color: #ff69b4 !important;
}
.pink .btn-primary:hover,
.pink .btn-primary:focus {
  background-color: #f680a0 !important;
  border-color: #f680a0 !important;
}
.pink .next-available-text {
  color: #f680a0 !important;
}
.pink .titleactive,
.pink .big-bar2 {
  border: solid 1px #f680a0;
  background-color: #f680a0;
  color: #fff;
}
.pink .bg-white-reason:hover {
  background-color: #f680a0 !important;
  color: #fff !important;
  border: unset !important;
}

.pink .react-calendar__navigation__label,
.pink .drak-blue-btn {
  background-color: #f680a0 !important;
  color: #fff !important;
  border: solid 1px #f680a0 !important;
}
.pink .slot_button {
  color: #fff !important;
}
.pink .blue-color {
  color: #f680a0 !important;
}
.pink .blue-f-colr {
  color: #f680a0 !important;
}

body .pink .app_button {
  background-color: #f680a0 !important;
}
body .pink .app_button.active,
body .pink .app_button:hover {
  background-color: #e93e70 !important;
}
body .pink .mbtnv.app_button.active,
body .pink .mbtnv.app_button:hover {
  background-color: transparent !important;
}

body .pink .react-calendar__navigation__arrow {
  background-color: #f680a0 !important;
  color: #fff !important;
  border: solid 1px #f680a0 !important;
}

/* green color theme end */

.pink .patientalertYes {
  background-color: #f680a0 !important;
}
.pink .selected-reason-apt {
  color: #f680a0 !important;
  background: none;
}
.pink .selected-reason-apt.mpk {
  color: #f680a0 !important;
  background: none;
}
.calicon {
  position: absolute;
  right: 0;
  margin-top: 12px;
  margin-right: 10px;
  color: #fff;
  cursor: pointer;
}
.react-calendar__navigation {
  position: relative;
}

.leftarrow {
  position: absolute;
  color: #fff;
  left: 11px;
  top: 15px;
  cursor: pointer;
}

.react-calendar__tile--active {
  background: #f3f1f173 !important;
  color: #000 !important;
}

.pink .sdown,
.pink .sdown a {
  line-height: 47px;
  color: #f680a0;
  text-decoration: none;
}

.hide_asp {
  display: none;
}
.no_app {
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 34px !important;
  text-decoration: none !important;
  color: #000 !important;
}
.no_app a {
  text-decoration: none !important;
  color: #000 !important;
}

.slotlog {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #3e7ebc !important;
  flex-direction: column;
}
.pink .slotlog {
  color: #f680a0;
}
#pink .pink.poptitle {
  background-color: #f680a0;
}

.poptitle {
  background-color: #3e7ebc;
  color: #fff;
  font-size: 18px !important;
  padding: 10px 0px;
}
#timimg {
  margin-bottom: 10px;
}
.cbtntt {
  float: right;
  cursor: pointer;
  position: absolute;
  top: 7px;
  right: 10px;
  color: #fff;
}

.pink .MuiButton-outlined.otnbtn-primary {
  border-color: #f680a0 !important;
  color: #f680a0 !important;
}

.dob_field {
  padding: 10px !important;
  text-align: center;
}
.patientalertYes a {
  color: #fff;
  text-decoration: none;
}

.pink .re_otp {
  border-color: #f680a0 !important;
  padding: 10px 60px !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  color: #f680a0 !important;
}
.pink .re_otp:hover {
  background-color: #f680a0 !important;
  color: #fff !important;
}

.blue .re_otp {
  border-color: #00b8e9 !important;
  color: #00b8e9 !important;
  padding: 10px 60px !important;
  font-weight: 700 !important;
  font-size: 18px !important;
}
.blue .call {
  border-color: #00b8e9 !important;
  color: #00b8e9 !important;
  margin-top: 30px;
  text-transform: capitalize;
}
.pink .call {
  border-color: #f680a0 !important;
  color: #f680a0 !important;
  margin-top: 30px;
  text-transform: capitalize;
}
.blue .re_otp:hover {
  background-color: #3e7ebc !important;
  color: #fff !important;
}

#blue .yes_btn,
#blue .no_btn {
  background-color: #00b8e9 !important;
  color: #fff !important;
}
#patmsg {
  text-align: left !important;
}
#pink .yes_btn,
#pink .no_btn {
  background-color: #f680a0 !important;
  color: #fff !important;
}
.mobile {
  display: none !important;
}
@media (max-width: 380px) {
  .mobile {
    display: block !important;
  }
  .des {
    display: none;
  }
}

.pgetitle {
  color: #376db6;
  font-weight: bold !important;
  font-size: 20px !important;
  margin-bottom: 15px !important;
  text-align: left;
}
.pink .pgetitle {
  color: #f680a0 !important;
}
.practice_info * {
  font-family: "Roboto", sans-serif !important;
}
.bannertitle {
  color: #376db6;
  font-weight: bold !important;
  font-size: 24px !important;  
  text-align: center;
  font-family: "Roboto", sans-serif !important;
}
.pink .bannertitle {
  color: #f680a0 !important;
}

.pgetitle.acc {
  margin-bottom: 20px;
}

.openhrs tr td {
  padding: 5px;
  padding-left: 0px;
}
.headpgetitle {
  text-align: center;
}
.hr-divider {
  margin: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  height: 1px;
  background: #0e0d0d;
}

@media (max-width: 460px) {
  .openhrs {
    max-width: 100% !important;
  }
}
.alert_new .css-1pxa9xg-MuiAlert-message {
  padding: 8px 0;
  min-width: 0;
  overflow: auto;
  color: gray;
}
.alert_new.css-18ui9jn-MuiPaper-root-MuiAlert-root,
.alert_new.css-jbopxz-MuiPaper-root-MuiAlert-root {
  border-color: gray;
  border-radius: 10px;
}
.alert_new .MuiAlert-icon {
  color: gray !important;
}
.adds_div {
  color: #fff;
  font-weight: bold !important;
}
.m_info_b {
  text-transform: capitalize !important;
  font-size: 15px !important;
  border-radius: 24px !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  font-weight: 600 !important;
}
.adds_div {
  margin-top: 35px !important;
  margin-right: 20px !important;
}
.hr-profile2 {
  margin-left: -24px !important;
  margin-top: 15px !important;
  margin-bottom: 10px !important;
  height: 1px;
  margin-right: -24px !important;
  background: #0e0d0d;
}

@media (min-width: 600px) and (max-width: 1024px) {
  #Tab_view .header {
    line-height: 0px !important;
  }
  #Tab_view .d_button {
    margin-bottom: 10px !important;
  }
  #Tab_view .div-Continue {
    float: right !important;
  }
  #Tab_view .mt--15 {
    text-align: center !important;
  }
}
.adds_div.prinfo{
  margin-top: 0px !important;
  margin-right: 0px !important;
}


@media (max-with:882){
.desktop_view{
  display: none;
}
}
/* only screen and (min-width:321px) and (max-width:768px) */

@media (max-width: 768px) {
  .mobile-block {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;yBAEuB;EACvB,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;aACW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;;;;;GAKG;AACH;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAO;AACT;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE;mFACiF;EACjF,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE;;;;;;IAME,4BAA4B;EAC9B;AACF;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;;EAE3B;mFACiF;AACnF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B;mFACiF;AACnF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE;mFACiF;EACjF,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE;mFACiF;EACjF,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;;;;;GAKG;AACH;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;mFACiF;EACjF,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX;mFACiF;;EAEjF,gBAAgB;EAChB,eAAe;AACjB;AACA;;;EAGE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX;mFACiF;;EAEjF,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB;mFACiF;EACjF,2BAA2B;EAC3B,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;EACpC,iCAAiC;EACjC,mFAAmF;AACrF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;AACf;AACA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,oEAA+D;EAC/D,iBAAiB;AACnB;;AAEA;;EAEE,oEAA+D;EAC/D,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,oEAA+D;IAC/D,iBAAiB;EACnB;EACA;;IAEE,oEAA+D;IAC/D,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,yBAAyB;EAC3B;GACC;IACC,wBAAwB;EAC1B;EACA;IACE,iCAAiC;IACjC,yBAAyB;IACzB,wBAAwB;IACxB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,6BAA6B;EAC/B;EACA;;KAEG;EACH;IACE,2BAA2B;IAC3B,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,cAAc;EAChB;EACA;IACE,oEAA4D;IAC5D,iBAAiB;EACnB;EACA;;IAEE,oEAAyE;IACzE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;AACF;AACA;EACE;;IAEE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oEAA4D;IAC5D,iBAAiB;EACnB;;EAEA;;IAEE,oEAAyE;IACzE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,cAAc;IACd,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,qBAAqB;EACvB;EACA;IACE,4BAA4B;IAC5B,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;IACX,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,2BAA2B;IAC3B,8BAA8B;EAChC;EACA;IACE,4BAA4B;IAC5B,+BAA+B;EACjC;AACF;AACA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,4BAA4B;IAC5B,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;;;;;;;;;;;;EAYE,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,WAAW;EACX,cAAc;EACd,UAAU;EACV,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B;uFACqF;AACvF;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,oCAAoC;EACpC;yCACuC;AACzC;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,YAAY;;AAEZ;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;;;GAGG;AACH;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,eAAe;;AAEf;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE;uFACqF;EACrF,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB,SAAS;AACT;EACE,yBAAyB;EACzB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;AACrB;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;AACA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA,0BAA0B;;AAE1B;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;EAC1B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;;AAGA;AACA;EACE,aAAa;AACf;AACA;AACA,4DAA4D;;AAE5D;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Oxygen:wght@300;400;700&display=swap\");\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;0,900;1,900&display=swap');\nbody {\n  margin: 0;\n  font-family: \"Oxygen\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\",\n    \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-weight: 400 !important;\n}\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 10vh;\n}\n.header-logo {\n  margin-top: -5px;\n}\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.mt-m4 {\n  margin-top: 1.5rem !important;\n}\n.mt--10 {\n  margin-top: 10px;\n}\n.bor-r-8 {\n  border-radius: 8px;\n  font-size: 20px;\n}\n.color-00B8E9 {\n  color: #00b8e9 !important;\n}\n.shownotbookmsg {\n  margin-top: 8px !important;\n  font-size: 14px;\n  font-weight: 600;\n  color: #999;\n}\n.cursor {\n  cursor: pointer;\n}\n.div-Continue {\n  width: 100%;\n  padding: 6px 4.8rem !important;\n}\n.hide-mob {\n  display: block;\n}\n.InvalidRequest {\n  margin-bottom: 32px !important;\n  font-weight: 800 !important;\n  font-size: 25px !important;\n}\na.navbar-brand {\n  font-weight: 700 !important;\n  font-size: 20px !important;\n}\n.show-mob {\n  display: none;\n}\n.show-web {\n  display: block;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n.px1 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.pad-profile {\n  padding: 0 30px;\n}\n.slot-width-w {\n  width: 23%;\n  margin: 3px;\n}\n.cal-size {\n  width: 80.9% !important;\n  margin-left: 9.5%;\n}\n.p-10 {\n  padding: 10rem !important;\n}\n.group {\n  display: flex;\n  justify-content: space-between;\n}\n.patientalertYes {\n  background-color: #3e7ebc !important;\n  padding: 40px 25px;\n  font-size: 16px;\n  text-align: center;\n  font-weight: 500;\n  color: #fff;\n  border-radius: 8px;\n}\n.ReasonTitle {\n  background-color: #3e7ebc;\n  padding: 0.7rem 2rem;\n  border-radius: 35px;\n  color: #fff;\n}\n\n.non-selected-slot {\n  background-color: #fff !important;\n  --bs-btn-color: #eee !important;\n  --bs-btn-border-color: #eee !important;\n}\n.non-selected-slot:hover {\n  background-color: #fff !important;\n  --bs-btn-color: #eee !important;\n  --bs-btn-border-color: #eee !important;\n}\n.bg-white-reason {\n  border: solid 1px #515151;\n  background-color: #fff;\n  color: #373737;\n}\n.titleactive {\n  border: solid 1px #3e7ebc;\n  background-color: #3e7ebc;\n  color: #fff;\n}\n.header {\n  /* height: 90px; */\n  height: 75px;\n  line-height: 90px;\n  color: \"#fff\";\n}\n\n.LocName {\n  margin-left: 0;\n  font-size: 1.4rem;\n  font-weight: 900;\n}\n.content-body {\n  margin-top: 100px;\n  margin-bottom: 40px;\n}\n.profile-img {\n  width: 100px;\n}\n.top_button {\n  background-color: #00b8e9 !important;\n  color: #fff;\n  padding: 8px;\n  text-transform: CAPITALIZE;\n  border-radius: 5px;\n  font-weight: bold;\n  font-size: 20px;\n}\n.blue.header {\n  background-color: #3e7ebc !important;\n}\n.pink.header {\n  background-color: #f680a0 !important;\n}\n.header-logo {\n  padding: 6px;\n  background-color: unset;\n  border-radius: 3px;\n  width: 85px !important;\n  height: 70px !important;\n}\n/* .pink .pink_header-logo{\n  padding: 6px;\n  background-color: unset;\n max-width:214px;\n background: #fff;\n} */\n.pink .pink_header-logo {\n  padding: 5px;\n  background-color: unset;\n  max-width: 135px;\n  background: #fff;\n  margin-top: -6px;\n  border-radius: 6px;\n}\n.list_symtom li {\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n.float-end1 {\n  text-align: center;\n  margin-top: 10px !important;\n  flex: 1;\n}\n.buttons {\n  color: #fff;\n  padding-left: 40%;\n  padding-right: 40%;\n  margin-top: 33px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  background: #388fa2 !important;\n  width: 100%;\n}\n.v_button {\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n  font-weight: 700 !important;\n  margin-bottom: 10px !important;\n}\n@media (min-width: 1400px) {\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 1300px !important;\n  }\n}\n.cus-breadcrumb {\n  display: table;\n  margin-left: 100% !important;\n  margin-top: -24px !important;\n  transform: rotate(270deg);\n  color: #fff !important;\n}\n.username {\n  font-weight: 600;\n  font-size: 20px;\n}\n.next-available-text {\n  font-size: 16px !important;\n  color: #00b8e9 !important;\n  font-weight: 400 !important;\n\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n}\n\n.sub_text.text-muted {\n  font-size: 16px !important;\n  color: #373737 !important;\n  font-weight: 400 !important;\n  font-weight: 800 !important;\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n}\n.breadcrumb {\n  font-weight: 700 !important;\n}\n.sub_txt {\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n  font-weight: 700 !important;\n  font-size: 18px !important;\n  line-height: 23px !important;\n}\n.main_txt {\n  font-weight: 700 !important;\n  font-size: 24px !important;\n  margin-bottom: 10px !important;\n}\n.btn-primary {\n  background-color: #3e7ebc !important;\n  border-color: #3e7ebc !important;\n}\n.btn-primary:hover,\n.btn-primary:focus {\n  background-color: #3e7ebc !important;\n  border-color: #3e7ebc !important;\n}\n\n.left-content {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n.sub_txt2 {\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 16px !important;\n  line-height: 23px !important;\n}\n.normal_txt p {\n  text-align: justify;\n}\n.bi_title {\n  font-size: 18px;\n  margin-bottom: 16px;\n  margin-top: 20px;\n}\n.app_button {\n  margin: 5px;\n  padding-left: 13px !important;\n  padding-right: 13px !important;\n}\n/* .availableslots .slotbtn .app_button{\n  margin:10px;\n  padding:0px !important;\n  width:171px;\n  height: 60px;\n} */\n.DOBLable {\n  font-size: 18px;\n  color: #555;\n  margin-bottom: 12px;\n}\n.availableslots .slotbtn .app_button {\n  margin: 6px;\n  padding: 10px !important;\n  font-weight: 400 !important;\n}\n\n.react-calendar {\n  width: 100% !important;\n  height: auto;\n  /* height: 350px; */\n}\n\nabbr[title] {\n  -webkit-text-decoration: none !important;\n  text-decoration: none !important;\n  cursor: help !important;\n  text-decoration-skip-ink: none !important;\n}\n.react-calendar__month-view__weekdays__weekday {\n  padding: 15px !important;\n  background: #e6e6e5 !important;\n  border-right: 1px solid #fff !important;\n  color: #373737 !important;\n  font-weight: bold;\n  border: solid #fff !important;\n  border-radius: 6px;\n  margin-top: 1px;\n}\n.react-calendar__tile--active {\n  background: #388fa2 !important;\n  color: white;\n}\n.react-calendar__tile {\n  padding: 15px !important;\n}\n.react-calendar__navigation button {\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n  font-weight: 700 !important;\n  min-width: 44px;\n  background: none;\n  font-size: 24px;\n}\n.react-calendar__navigation__next-button,\n.react-calendar__navigation__prev-button {\n  font-size: 35px !important;\n}\n.react-calendar__navigation {\n  display: flex;\n  height: 55px !important;\n  margin-bottom: 0px !important;\n}\n\nbody .btn-outline-secondary {\n  background-color: #00b8e9;\n  --bs-btn-color: #fff;\n  --bs-btn-border-color: #00b8e9;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #00b8e9;\n  --bs-btn-hover-border-color: #00b8e9;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #00b8e9;\n  --bs-btn-active-border-color: #00b8e9;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #00b8e9;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #00b8e9;\n  --bs-gradient: none;\n}\n\n.availableslots .react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n  border: none;\n}\n.slotbtn .react-calendar__navigation button:hover,\n.slotbtn .react-calendar__navigation button:focus {\n  background: none !important;\n}\n\n.big-bar {\n  background: #388fa2;\n  margin-left: 11px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.big-bar p {\n  color: #fff;\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n\n  font-weight: 700;\n  font-size: 24px;\n}\nbody .btn.disabled,\n.btn:disabled,\nfieldset:disabled .btn {\n  color: #515151;\n  pointer-events: none;\n  border-color: #515151;\n  opacity: 0.2;\n}\n.frm_side p {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 30px;\n}\n.mid_cnt {\n  margin: 0 30px;\n}\n.big-bar2 {\n  background: #00b8e9;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-radius: 5px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.big-bar2 p {\n  color: #fff;\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n\n  font-weight: 700;\n  font-size: 24px;\n}\n.form-control {\n  /* margin-top: 15px; */\n  display: block !important;\n  font-family: Oxygen, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif !important;\n  font-weight: 400 !important;\n  width: 100% !important;\n  padding: 0.375rem 1.75rem !important;\n  height: 50px;\n  font-size: 18px !important;\n  line-height: 1.5 !important;\n  color: #495057 !important;\n  background-color: #fff !important;\n  background-clip: padding-box !important;\n  border: 1px solid #ced4da !important;\n  border-radius: 0.25rem !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n.genter_class {\n  margin-left: 28px;\n}\n.book_appbtn {\n  color: #fff !important;\n  background-color: #00b8e9 !important;\n  padding: 10px 40px !important;\n  border: unset !important;\n  font-weight: 800 !important;\n}\n\n.book_appbtn:hover {\n  color: #fff !important;\n  background-color: #00b8e9 !important;\n  padding: 10px 40px !important;\n  border: unset !important;\n  font-weight: 800 !important;\n}\n\np.error {\n  color: #d32f2f;\n  margin-top: 5px;\n  font-size: 13px;\n}\n.inputStyle {\n  width: 3rem !important;\n  height: 3rem;\n  margin: 0 1rem;\n  font-size: 2rem;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n}\n.peotp {\n  font-weight: 400 !important;\n  font-size: 18px !important;\n}\n.rotp {\n  font-weight: 700 !important;\n  font-size: 18px !important;\n}\n.book_appbtn2 {\n  font-weight: 700 !important;\n  font-size: 18px !important;\n  margin-top: 20px;\n  padding: 10px 68px !important;\n  background-color: #00b8e9 !important;\n  border: unset !important;\n}\n.book_appbtn3 {\n  font-weight: 700 !important;\n  font-size: 18px !important;\n  margin-top: 20px;\n  padding: 10px 25px !important;\n  background-color: #00b8e9 !important;\n  border: unset !important;\n}\n.peotp1 {\n  font-weight: 700 !important;\n  font-size: 18px !important;\n}\n.d_button {\n  padding-left: 18px !important;\n  padding-right: 18px !important;\n  font-size: 16px !important;\n  font-weight: bold !important;\n}\n\n.mb_bottom,\n.homepage_mobile {\n  display: none;\n}\n.d-flex.small_view,\n.small_view {\n  display: none !important;\n}\n\n.mobile_view {\n  display: none;\n}\n.desktop_hide {\n  display: none;\n}\n.fixed-top {\n  background-image: url(assets/images/headerBGWeb.png) !important;\n  background: round;\n}\n\n.pink.fixed-top,\n.pink.mdfixed-top {\n  background-image: url(assets/images/Header_pink.png) !important;\n  background: round;\n}\n\n.MuiAlert-filledWarning {\n  background-color: red !important;\n}\n.css-rgrmo-MuiButtonBase-root-MuiRadio-root.Mui-checked {\n  color: #00b8e9 !important;\n}\n.css-15vr3e2.Mui-checked {\n  color: #00b8e9 !important;\n}\n.desktop_view {\n  display: block;\n}\n\n@media (max-width: 980px) {\n  .profile-billing {\n    text-align: justify;\n  }\n  .desktop_hide {\n    display: block;\n  }\n  .cus-breadcrumb {\n    display: table;\n    margin-left: 100% !important;\n    margin-top: -24px !important;\n    transform: rotate(270deg);\n    color: #fff !important;\n  }\n  .fixed-top {\n    background-image: url(assets/images/headerBGWeb.png) !important;\n    background: round;\n  }\n  .pink.fixed-top,\n  .pink.mdfixed-top {\n    background-image: url(assets/images/Header_pink.png) !important;\n    background: round;\n  }\n\n  .mobile_view {\n    display: block !important;\n  }\n  .react-calendar__navigation__prev-button,\n  .react-calendar__navigation__next-button {\n    font-size: 26px !important;\n  }\n  .app_button {\n    font-size: 14px !important;\n    margin: 5px !important;\n  }\n  .bi_title {\n    font-size: 16px !important;\n  }\n  .mb_bottom,\n  .homepage_mobile {\n    display: block !important;\n  }\n   .desktop_view {\n    display: none !important;\n  } \n  .selected-reason-apt {\n    background-color: #fff !important;\n    color: #00b8e9 !important;\n    border: unset !important;\n    font-weight: 800 !important;\n    text-align: center;\n    padding: 5px;\n  }\n  .pink.selected-reason-apt {\n    background-color: #fff !important;\n    border: unset !important;\n    font-weight: 800 !important;\n    text-align: center;\n    padding: 5px;\n  }\n\n  .header .container {\n    text-align: center !important;\n  }\n  /* .navbar > .container {\n    display: block !important;\n  } */\n  .header .container a {\n    font-weight: 700 !important;\n    font-size: 16px;\n  }\n  .header .container img {\n    width: 100px;\n  }\n\n  .username {\n    font-weight: 700;\n    font-size: 16px;\n  }\n\n  .sub_text.text-muted {\n    font-size: 14px !important;\n  }\n  .d_button {\n    padding: 8px 8px !important;\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n    font-size: 13px !important;\n    font-weight: bold !important;\n    width: 100%;\n    max-width: 150px;\n  }\n  .div-Continue {\n    width: 100%;\n    padding: 10px 48px !important;\n    min-width: 170px;\n  }\n  .breadcrumb {\n    font-size: 14px !important;\n  }\n  .sub_txt {\n    font-size: 13px !important;\n  }\n  .btn2 {\n    width: 100% !important;\n  }\n  .main_txt {\n    font-size: 16px !important;\n  }\n  .small_text,\n  .n_av,\n  .smbtn {\n    font-size: 12px !important;\n  }\n  .smbtn {\n    margin: 0px !important;\n  }\n}\n\np.small_view_e {\n  display: none;\n}\np.large_view_e {\n  display: block;\n}\n@media (max-width: 500px) {\n  .LocName {\n    font-size: 15px;\n    font-weight: 900;\n  }\n  .breadcrumb {\n    margin-left: 5px !important;\n  }\n  .inmobile {\n    max-width: 100%;\n  }\n  .d_view {\n    display: none !important;\n  }\n\n  p.small_view_e {\n    display: block;\n  }\n  p.large_view_e {\n    display: none;\n  }\n  .list_symtom li {\n    font-size: 12px;\n  }\n  .card-reason-pad {\n    padding: 21px 12px;\n  }\n  .ReasonTitle {\n    padding: 0.7rem 1rem !important;\n  }\n  .pd-0 {\n    padding: 0 !important;\n  }\n  .mt--10 {\n    margin-top: 10px;\n  }\n  .DivdateOfBirthDMY {\n    padding: 5px 3px !important;\n  }\n  .ml-10 {\n    margin-left: 10px;\n  }\n  .patientalertYes {\n    padding: 40px 14px;\n  }\n  .radio_button label span {\n    font-size: 12px !important;\n    padding: 1px;\n  }\n  .radio_button .css-j204z7-MuiFormControlLabel-root {\n    margin-right: 13px !important;\n    margin-left: 3px;\n  }\n  .mt-m4 {\n    margin-top: 0.25rem !important;\n  }\n  .show-mob {\n    display: block;\n  }\n  .fixed-top {\n    background-image: url(assets/images/headerBG.png) !important;\n    background: round;\n  }\n  .pink.fixed-top,\n  .pink.mdfixed-top {\n    background-image: url(assets/images/Header_bar_pink_color.png) !important;\n    background: round;\n  }\n  .show-web {\n    display: none;\n  }\n  .navbar-brand {\n    float: left;\n  }\n  .mb-text-center {\n    text-align: center !important;\n  }\n  .pad-profile {\n    padding: 0 10px;\n  }\n  .pd-0-3 {\n    padding: 0px 3px !important;\n  }\n  .big-bar2 p {\n    font-size: 21px;\n  }\n  .ml-3 {\n    margin-left: 18px;\n  }\n  .ml-26 {\n    margin-left: 26px;\n  }\n  .font-14 {\n    font-size: 14px !important;\n  }\n  .profile-img {\n    width: 80px;\n    height: 80px;\n  }\n  .mt--15 {\n    margin-top: -15px;\n  }\n  .ml-37 {\n    margin-left: 30% !important;\n  }\n  .slot-width-w {\n    width: 30.5%;\n    margin: 3px;\n  }\n  .cal-size {\n    width: 100% !important;\n    margin-left: 0;\n  }\n  .width-38 {\n    width: 100% !important;\n  }\n  .ml--20 {\n    margin-left: -20px;\n  }\n  .cus-breadcrumb {\n    display: block;\n    margin-left: 93% !important;\n    margin-top: -20px !important;\n    transform: rotate(270deg);\n    color: #fff !important;\n  }\n  .ml--10 {\n    margin-left: -10px;\n  }\n  .card-reason-pad {\n    padding: 21px 12px !important;\n  }\n  .width-96 {\n    margin: 0 4px !important;\n    width: 100% !important;\n    margin-top: 13px !important;\n  }\n  .rotp {\n    font-size: 12px !important;\n  }\n  .pd-0 {\n    padding: 0px !important;\n  }\n  .content-body {\n    margin-top: 88px !important;\n  }\n  .next-available-text {\n    font-size: 14px !important;\n  }\n  .cl-gray {\n    color: #373737 !important;\n  }\n  .d-flex.small_view,\n  .small_view {\n    display: block !important;\n  }\n  .peotp {\n    font-size: 15px !important;\n  }\n\n  .mobile_view2,\n  .d-flex.large_view {\n    display: none !important;\n  }\n  .mid_cnt {\n    margin: 0px !important;\n  }\n  .divider_mb {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n    margin-top: 30px !important;\n  }\n  .react-calendar__navigation button {\n    font-size: 16px;\n  }\n  .dateOfBirthDDMMYYYY {\n    padding: 0.375rem 0.7rem !important;\n  }\n  .pd-r {\n    padding-right: 0px;\n  }\n  .header-logo {\n    width: 70px !important;\n    height: 60px !important;\n  }\n  .react-calendar__navigation__prev2-button {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n  .react-calendar__navigation__next2-button {\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n  .DOBLable {\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 12px;\n  }\n}\n@media (max-width: 380px) {\n  .react-calendar__navigation__prev2-button,\n  .react-calendar__navigation__next2-button {\n    display: none !important;\n  }\n  .show-mob {\n    display: block !important;\n  }\n  .ml-2 {\n    margin-left: 2px;\n  }\n  .mt--10 {\n    margin-top: 10px;\n  }\n  .fixed-top {\n    background-image: url(assets/images/headerBG.png) !important;\n    background: round;\n  }\n\n  .pink.fixed-top,\n  .pink.mdfixed-top {\n    background-image: url(assets/images/Header_bar_pink_color.png) !important;\n    background: round;\n  }\n  .DOBLable {\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 12px;\n  }\n  .ml-10 {\n    margin-left: 10px;\n  }\n  .pd-r {\n    padding-right: 0px !important;\n  }\n  .ml-00 {\n    margin-left: 0px;\n  }\n  .dateOfBirthDMY {\n    padding: 5px 10px !important;\n  }\n  .DivdateOfBirthDMY {\n    padding: 5px 3px !important;\n  }\n  .css-1jaw3da {\n    margin-right: 12px !important;\n  }\n  .cus-breadcrumb {\n    display: block;\n    margin-left: 93% !important;\n    margin-top: -20px !important;\n    transform: rotate(270deg);\n    color: #fff !important;\n  }\n  .mr-0 {\n    margin-right: 0px;\n  }\n  .show-web {\n    display: none;\n  }\n  .patientalertYes {\n    padding: 40px 14px;\n  }\n  .patientalertYes a {\n    color: #fff;\n    text-decoration: none;\n  }\n  .radio_button .css-j204z7-MuiFormControlLabel-root {\n    margin-right: 3px !important;\n    margin-left: 0;\n  }\n  .radio_button label span {\n    font-size: 11px !important;\n    padding-left: 0px;\n  }\n  .slot-width-w {\n    width: 31%;\n    margin: 3px;\n    font-size: 13px !important;\n  }\n  .mt-m4 {\n    margin-top: 0.25rem !important;\n  }\n  .pad-profile {\n    padding: 0 10px;\n  }\n  .ml-26 {\n    margin-left: 26px;\n  }\n  .ml--20 {\n    margin-left: -20px;\n  }\n  .ml--10 {\n    margin-left: -10px;\n  }\n  .card-reason-pad {\n    padding: 21px 12px !important;\n  }\n  .pd-m-0 {\n    padding: 5px !important;\n  }\n  .ml-5 {\n    margin-left: 5px !important;\n  }\n  .react-calendar__month-view__weekdays__weekday {\n    padding: 4px !important;\n  }\n  .react-calendar__tile {\n    padding: 10px !important;\n  }\n  .react-calendar {\n    height: 330px;\n  }\n  .slot_button {\n    padding: 8px !important;\n  }\n  .small_text,\n  .n_av,\n  .smbtn {\n    font-size: 10px !important;\n  }\n  .big-bar2 p {\n    font-size: 16px !important;\n  }\n  .app_button {\n    font-size: 13px !important;\n    margin: 5px !important;\n    padding: 10px !important;\n  }\n  .bopt {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n  .smt {\n    font-size: 14px;\n  }\n  .header-logo {\n    width: 70px !important;\n    height: 60px !important;\n  }\n  .react-calendar__navigation__prev2-button {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n  }\n  .react-calendar__navigation__next2-button {\n    border-top-right-radius: 6px;\n    border-bottom-right-radius: 6px;\n  }\n}\n@media (max-width: 980px) {\n  .book_appbtn {\n    font-size: 16px !important;\n    font-weight: 800 !important;\n    width: 100% !important;\n  }\n  .radio_button label span {\n    font-size: 14px;\n  }\n  .genter_class {\n    margin-left: 0px;\n  }\n  .smbtn {\n    font-size: 11px !important;\n  }\n  .m_button {\n    margin: 0px;\n  }\n  .big-bar {\n    background: #388fa2;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  .big-bar p {\n    font-size: 16px;\n  }\n  .m_button {\n    margin: 5px;\n    padding: 7px 17px !important;\n    font-size: 12px !important;\n  }\n  .form-control {\n    font-size: 16px !important;\n  }\n}\n.reason {\n  font-size: 14px !important;\n  font-weight: bold !important;\n}\nbody,\nlabel,\np,\na,\nspan,\ndiv,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Oxygen\" !important;\n}\n.pd-10 {\n  padding: 8px;\n}\n.b-width-full {\n  width: 99%;\n  padding: 6px !important;\n}\n.width-96 {\n  border-bottom: solid #d9d9d9 1px;\n  color: #fff;\n  margin: 0 28px;\n  width: 96%;\n  margin-top: 5px;\n}\n.list-group-item {\n  border: unset !important;\n}\n.mt--20 {\n  margin-top: -20px !important;\n}\n.pat-title {\n  font-size: 18px;\n  color: #515151;\n}\n.css-odx107-MuiPaper-root {\n  border-radius: 10px !important;\n  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.04),\n    0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;\n}\n.hr-profile {\n  margin: 0px !important;\n  margin-top: 27px !important;\n  margin-bottom: 10px !important;\n  height: 1px;\n  background: #0e0d0d;\n}\n\n.ml-37 {\n  margin-left: 37%;\n}\n.width-38 {\n  width: 38%;\n  margin: 0;\n}\n.btn-blue {\n  background-color: #00b8e9 !important;\n  border-color: #00b8e9 !important;\n}\n.bg-white-reason:hover {\n  background-color: #00b8e9 !important;\n  color: #fff !important;\n  border: unset !important;\n}\n.slot_button:hover {\n  background-color: #00b8e9 !important;\n  color: #fff !important;\n  border: unset !important;\n}\n.app_button {\n  background-color: #fff !important;\n  color: #eee !important;\n  border: solid 1px #eee !important;\n}\n\n.v_button {\n  background-color: #00b8e9 !important;\n  /* background-color: #bbdeeb !important;   */\n  color: #fff !important;\n  /* color: #000 !important; */\n  border: unset !important;\n}\n\n.slot_button {\n  background-color: #f0efef73 !important;\n  color: #515151 !important;\n  border: solid 1px #515151 !important;\n  padding: 10px !important;\n}\n.div-right {\n  float: right;\n}\n\n.color-515151 {\n  color: #515151 !important;\n}\n.color-37 {\n  color: #373737 !important;\n}\n.bg-white-reason .color-37:hover {\n  color: #fff !important;\n}\n.bg-blue-btn {\n  color: #fff !important;\n  background-color: #4565ad !important;\n  border: solid 1px #4565ad !important;\n  /* background-color: #3e7ebc !important;\n  border: solid 1px #3e7ebc !important; */\n}\n.font-20 {\n  font-size: 19px;\n}\n.slot-card {\n  padding: 2rem 3rem !important;\n}\n.blue-color {\n  color: #3e7ebc !important;\n}\n\n.react-calendar__navigation__label {\n  background-color: #3e7ebc !important;\n  color: #fff !important;\n  border: solid 1px #3e7ebc !important;\n}\n.react-calendar__navigation__arrow {\n  background-color: #3e7ebc !important;\n  color: #fff !important;\n  border: solid 1px #3e7ebc !important;\n}\n.react-calendar__navigation {\n  border: unset !important;\n}\n.react-calendar {\n  border: unset !important;\n}\n.react-calendar__tile {\n  border: solid #fff !important;\n  border-radius: 6px;\n  color: #373737;\n  background: #f3f1f173 !important;\n}\n.react-calendar__month-view__days__day--weekend {\n  color: unset !important;\n}\n.highlight {\n  background: #edfafd !important;\n  color: #373737 !important;\n}\n.selecteddate {\n  background: #f0eeee !important;\n  color: #373737 !important;\n}\n.react-calendar__tile--active {\n  background: #00b8e9 !important;\n  color: #fff !important;\n}\n\n/*pink css */\n\n.pink .highlight {\n  background: #e6e6e5 !important;\n  color: #000 !important;\n}\n.pink .selecteddate {\n  background: #e93e70 !important;\n  color: #fff !important;\n}\n/* .pink .react-calendar__tile--active{\n  background: #e93e70 !important;\n  color: #FFF !important;\n} */\n.pink .react-calendar__tile:hover {\n  /* background:#E6E6E5 !important; */\n  color: #000 !important;\n}\n\n/* blue color */\n\n.blue .highlight {\n  /* background:#E6E6E5 !important; */\n  background: #bbdeeb !important;\n  color: #000 !important;\n}\n.blue .selecteddate {\n  background: #3e7ebc !important;\n  color: #fff !important;\n}\n.pink .react-calendar__tile--active.selecteddate {\n  background: #e93e70 !important;\n  color: #fff !important;\n}\n.blue .react-calendar__tile:hover {\n  /* background:#E6E6E5 !important; */\n  color: #000 !important;\n}\n\n.box-design {\n  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.04),\n    0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;\n  border: unset;\n  border-radius: 10px;\n}\n.blue-f-colr {\n  color: #3e7ebc;\n  font-weight: 800 !important;\n}\n.symtoms {\n  font-size: 15px !important;\n  color: #373737 !important;\n}\n.drak-blue-btn {\n  background: #3e7ebc !important;\n}\n.success-icon {\n  width: 130px;\n}\n.list-group-item-action:active {\n  background-color: unset !important;\n}\n.list-group-item-action:hover {\n  background-color: unset !important;\n}\n.mt--0 {\n  margin: 0 !important;\n}\n\n.h-27 {\n  height: 30rem;\n}\n\n/* .alert_new .MuiAlert-icon {\n  color: #38c390 !important;\n} */\n\n.closebtn {\n  float: right;\n  cursor: pointer;\n}\n.breadcrumb {\n  cursor: pointer;\n}\n\n/* dynamic color code */\n/*green */\nbody .pink .btn-outline-secondary {\n  background-color: #f680a0;\n  --bs-btn-color: #fff;\n  --bs-btn-border-color: #f680a0;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #f680a0;\n  --bs-btn-hover-border-color: #f680a0;\n  --bs-btn-focus-shadow-rgb: 108, 117, 125;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #f680a0;\n  --bs-btn-active-border-color: #f680a0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f680a0;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f680a0;\n  --bs-gradient: none;\n}\nbody .pink .btn-outline-secondary:hover,\nbody .pink .btn-outline-secondary:focus {\n  background-color: #f680a0 !important;\n  border-color: #f680a0 !important;\n  color: #ffffff;\n}\n.pink .btn-primary,\n.pink .btn-blue,\n.pink .top_button {\n  background-color: #f680a0 !important;\n  border-color: #f680a0 !important;\n  color: #ffffff;\n}\n.pink .color-00B8E9 {\n  color: #ff69b4 !important;\n}\n.pink .btn-primary:hover,\n.pink .btn-primary:focus {\n  background-color: #f680a0 !important;\n  border-color: #f680a0 !important;\n}\n.pink .next-available-text {\n  color: #f680a0 !important;\n}\n.pink .titleactive,\n.pink .big-bar2 {\n  border: solid 1px #f680a0;\n  background-color: #f680a0;\n  color: #fff;\n}\n.pink .bg-white-reason:hover {\n  background-color: #f680a0 !important;\n  color: #fff !important;\n  border: unset !important;\n}\n\n.pink .react-calendar__navigation__label,\n.pink .drak-blue-btn {\n  background-color: #f680a0 !important;\n  color: #fff !important;\n  border: solid 1px #f680a0 !important;\n}\n.pink .slot_button {\n  color: #fff !important;\n}\n.pink .blue-color {\n  color: #f680a0 !important;\n}\n.pink .blue-f-colr {\n  color: #f680a0 !important;\n}\n\nbody .pink .app_button {\n  background-color: #f680a0 !important;\n}\nbody .pink .app_button.active,\nbody .pink .app_button:hover {\n  background-color: #e93e70 !important;\n}\nbody .pink .mbtnv.app_button.active,\nbody .pink .mbtnv.app_button:hover {\n  background-color: transparent !important;\n}\n\nbody .pink .react-calendar__navigation__arrow {\n  background-color: #f680a0 !important;\n  color: #fff !important;\n  border: solid 1px #f680a0 !important;\n}\n\n/* green color theme end */\n\n.pink .patientalertYes {\n  background-color: #f680a0 !important;\n}\n.pink .selected-reason-apt {\n  color: #f680a0 !important;\n  background: none;\n}\n.pink .selected-reason-apt.mpk {\n  color: #f680a0 !important;\n  background: none;\n}\n.calicon {\n  position: absolute;\n  right: 0;\n  margin-top: 12px;\n  margin-right: 10px;\n  color: #fff;\n  cursor: pointer;\n}\n.react-calendar__navigation {\n  position: relative;\n}\n\n.leftarrow {\n  position: absolute;\n  color: #fff;\n  left: 11px;\n  top: 15px;\n  cursor: pointer;\n}\n\n.react-calendar__tile--active {\n  background: #f3f1f173 !important;\n  color: #000 !important;\n}\n\n.pink .sdown,\n.pink .sdown a {\n  line-height: 47px;\n  color: #f680a0;\n  text-decoration: none;\n}\n\n.hide_asp {\n  display: none;\n}\n.no_app {\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 34px !important;\n  text-decoration: none !important;\n  color: #000 !important;\n}\n.no_app a {\n  text-decoration: none !important;\n  color: #000 !important;\n}\n\n.slotlog {\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n  color: #3e7ebc !important;\n  flex-direction: column;\n}\n.pink .slotlog {\n  color: #f680a0;\n}\n#pink .pink.poptitle {\n  background-color: #f680a0;\n}\n\n.poptitle {\n  background-color: #3e7ebc;\n  color: #fff;\n  font-size: 18px !important;\n  padding: 10px 0px;\n}\n#timimg {\n  margin-bottom: 10px;\n}\n.cbtntt {\n  float: right;\n  cursor: pointer;\n  position: absolute;\n  top: 7px;\n  right: 10px;\n  color: #fff;\n}\n\n.pink .MuiButton-outlined.otnbtn-primary {\n  border-color: #f680a0 !important;\n  color: #f680a0 !important;\n}\n\n.dob_field {\n  padding: 10px !important;\n  text-align: center;\n}\n.patientalertYes a {\n  color: #fff;\n  text-decoration: none;\n}\n\n.pink .re_otp {\n  border-color: #f680a0 !important;\n  padding: 10px 60px !important;\n  font-weight: 700 !important;\n  font-size: 18px !important;\n  color: #f680a0 !important;\n}\n.pink .re_otp:hover {\n  background-color: #f680a0 !important;\n  color: #fff !important;\n}\n\n.blue .re_otp {\n  border-color: #00b8e9 !important;\n  color: #00b8e9 !important;\n  padding: 10px 60px !important;\n  font-weight: 700 !important;\n  font-size: 18px !important;\n}\n.blue .call {\n  border-color: #00b8e9 !important;\n  color: #00b8e9 !important;\n  margin-top: 30px;\n  text-transform: capitalize;\n}\n.pink .call {\n  border-color: #f680a0 !important;\n  color: #f680a0 !important;\n  margin-top: 30px;\n  text-transform: capitalize;\n}\n.blue .re_otp:hover {\n  background-color: #3e7ebc !important;\n  color: #fff !important;\n}\n\n#blue .yes_btn,\n#blue .no_btn {\n  background-color: #00b8e9 !important;\n  color: #fff !important;\n}\n#patmsg {\n  text-align: left !important;\n}\n#pink .yes_btn,\n#pink .no_btn {\n  background-color: #f680a0 !important;\n  color: #fff !important;\n}\n.mobile {\n  display: none !important;\n}\n@media (max-width: 380px) {\n  .mobile {\n    display: block !important;\n  }\n  .des {\n    display: none;\n  }\n}\n\n.pgetitle {\n  color: #376db6;\n  font-weight: bold !important;\n  font-size: 20px !important;\n  margin-bottom: 15px !important;\n  text-align: left;\n}\n.pink .pgetitle {\n  color: #f680a0 !important;\n}\n.practice_info * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n.bannertitle {\n  color: #376db6;\n  font-weight: bold !important;\n  font-size: 24px !important;  \n  text-align: center;\n  font-family: \"Roboto\", sans-serif !important;\n}\n.pink .bannertitle {\n  color: #f680a0 !important;\n}\n\n.pgetitle.acc {\n  margin-bottom: 20px;\n}\n\n.openhrs tr td {\n  padding: 5px;\n  padding-left: 0px;\n}\n.headpgetitle {\n  text-align: center;\n}\n.hr-divider {\n  margin: 0px !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  height: 1px;\n  background: #0e0d0d;\n}\n\n@media (max-width: 460px) {\n  .openhrs {\n    max-width: 100% !important;\n  }\n}\n.alert_new .css-1pxa9xg-MuiAlert-message {\n  padding: 8px 0;\n  min-width: 0;\n  overflow: auto;\n  color: gray;\n}\n.alert_new.css-18ui9jn-MuiPaper-root-MuiAlert-root,\n.alert_new.css-jbopxz-MuiPaper-root-MuiAlert-root {\n  border-color: gray;\n  border-radius: 10px;\n}\n.alert_new .MuiAlert-icon {\n  color: gray !important;\n}\n.adds_div {\n  color: #fff;\n  font-weight: bold !important;\n}\n.m_info_b {\n  text-transform: capitalize !important;\n  font-size: 15px !important;\n  border-radius: 24px !important;\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n  font-weight: 600 !important;\n}\n.adds_div {\n  margin-top: 35px !important;\n  margin-right: 20px !important;\n}\n.hr-profile2 {\n  margin-left: -24px !important;\n  margin-top: 15px !important;\n  margin-bottom: 10px !important;\n  height: 1px;\n  margin-right: -24px !important;\n  background: #0e0d0d;\n}\n\n@media (min-width: 600px) and (max-width: 1024px) {\n  #Tab_view .header {\n    line-height: 0px !important;\n  }\n  #Tab_view .d_button {\n    margin-bottom: 10px !important;\n  }\n  #Tab_view .div-Continue {\n    float: right !important;\n  }\n  #Tab_view .mt--15 {\n    text-align: center !important;\n  }\n}\n.adds_div.prinfo{\n  margin-top: 0px !important;\n  margin-right: 0px !important;\n}\n\n\n@media (max-with:882){\n.desktop_view{\n  display: none;\n}\n}\n/* only screen and (min-width:321px) and (max-width:768px) */\n\n@media (max-width: 768px) {\n  .mobile-block {\n    display: block;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
